var loginUid;

export default {
    loginUid
}


// WEBPACK FOOTER //
// ./src/api/global.js